import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import mapImage from "assets/images/SpechsSupplies/GlobalExpanding3-2.png";

const stats = [
  {
    icon: "storefront",
    label: "Sales Channel Discovery",
    sub: "We find the right markets for your products",
  },
  {
    icon: "handshake",
    label: "European Product Expertise",
    sub: "Connecting EU manufacturers to European & Asian buyers",
  },
  {
    icon: "public",
    label: "End-to-End Market Entry",
    sub: "From sourcing to sales, fully supported",
  },
];

function GlobalNetwork() {
  return (
    <MKBox
      sx={{
        position: "relative",
        overflow: "hidden",
        backgroundImage: `url(${mapImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Dark overlay */}
      <MKBox
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(50deg, rgba(5,10,30,0.97) 0%, rgba(5,10,30,0.92) 30%, rgba(5,10,30,0.55) 100%)",
        }}
      />

      <Container sx={{ position: "relative", zIndex: 1, py: { xs: 8, md: 12 } }}>
        <Grid container spacing={6} alignItems="center">
          {/* Left: text */}
          <Grid item xs={12} md={6}>
            <MKTypography
              variant="caption"
              sx={{
                color: "#4ecdc4",
                fontWeight: 700,
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                display: "block",
                mb: 2,
              }}
            >
              European Products · Global Markets
            </MKTypography>

            <MKTypography
              variant="h2"
              fontWeight="bold"
              sx={{
                color: "white !important",
                lineHeight: 1.2,
                mb: 3,
                textShadow: "0 2px 12px rgba(0,0,0,0.8)",
              }}
            >
              Taking European Products Global
            </MKTypography>

            <MKTypography
              variant="body1"
              sx={{ color: "rgba(255,255,255,0.92)", lineHeight: 1.8, mb: 5 }}
            >
              We help European manufacturers reach buyers across Europe and Asia. Beyond logistics,
              we provide comprehensive market entry support — identifying the right sales channels,
              building distribution partnerships, and navigating local markets on your behalf.
            </MKTypography>

            {/* Stat chips */}
            <MKBox sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {stats.map(({ icon, label, sub }) => (
                <MKBox
                  key={label}
                  sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2 }}
                >
                  <MKBox
                    sx={{
                      width: 32,
                      minWidth: 32,
                      height: 32,
                      borderRadius: "50%",
                      background: "rgba(78,205,196,0.15)",
                      border: "1px solid rgba(78,205,196,0.35)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Icon sx={{ color: "#4ecdc4", fontSize: "20px !important" }}>{icon}</Icon>
                  </MKBox>
                  <MKBox sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
                    <MKTypography
                      variant="body2"
                      fontWeight="bold"
                      sx={{ color: "white !important", lineHeight: 1.3, mb: 0 }}
                    >
                      {label}
                    </MKTypography>
                    <MKTypography
                      variant="caption"
                      sx={{ color: "rgba(255,255,255,0.75)", lineHeight: 1.3, display: "block" }}
                    >
                      {sub}
                    </MKTypography>
                  </MKBox>
                </MKBox>
              ))}
            </MKBox>
          </Grid>

          {/* Right: empty — map image fills the background */}
          <Grid item xs={12} md={6} />
        </Grid>
      </Container>
    </MKBox>
  );
}

export default GlobalNetwork;
